import React, { useContext, useEffect } from 'react'
import Modal from 'Components/Modal/ModalWithPortal'
import { NavigationContext } from 'Contexts/Navigation/NavigationContext'
import styles from './IosInstallPrompt.module.scss'
import Divider from 'Atoms/Divider'
import Typography from 'Atoms/Typography'
import Svg from 'Atoms/Svg'
import Image from 'next/image'

const IosInstallPrompt = () => {
    const { state: navigationState, dispatch: navigationDispatch } = useContext(NavigationContext)


    const onClose = () => {
        navigationDispatch({
            type: 'setIosInstallPromptState',
            payload: {
                iosInstallpromptState: {
                    isOpen: false
                }
            }
        })
    }

    if (!navigationState?.iosInstallpromptState?.isOpen) {
        return;
    }

    const isNotSafari = /CriOS|Brave|FxiOS/.test(navigator.userAgent);
    return <Modal
        id={"IosInstallPrompt"}
        outsideClick
        defaultOpened
        customOnClose={onClose}
    >
        <div className={styles.modal}>
            <Typography size={1} className={styles.header}><Svg icon={'SpeedwayMotors_Wheel_Full_Color'} size={2}></Svg>  Install Speedway Motors</Typography>
            <Divider />
            <Typography tone={'subtle'} size={0.875} className={styles.subtitle}>Install our web app on your device to easily access it anytime. No app store. No download. No hassle.</Typography>
            {isNotSafari &&
                <Typography className={styles.header}>1. Open our website in the Safari web browser</Typography>
            }


            <Typography className={styles.header}>{1 + isNotSafari}. Tap on <Image
                className={styles.example}
                src={`https://content.speedwaymotors.com/OtherImages/share.png.85b6b1e91806c5893fb836ef2dfbb20d.png`}
                width={16}
                height={16} /></Typography>
            <Typography className={styles.header}>{2 + isNotSafari}. Select <Typography size={0.875} className={styles.example} as={'span'}>Add to Home Screen</Typography></Typography>
        </div>


    </Modal>
}

export default IosInstallPrompt